<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span>
                        <ion-icon class="ion-padding-start" size="large" name="home"
                                  (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">AMMINISTRATORE - REPORT</span>
                    </div>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService?.user?.profileImg|s3Link"/>

                    </ion-avatar>
                </div>
                <app-add-bookmark slot="end" pageTitle="Report" url="/report"></app-add-bookmark>

            </ion-toolbar>
            <br/>

            <!-- edit da qui... -->
            <h3 class="panel-title">Rendimenti</h3>
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->
                        <div class="flex-row">
                            <div class="flex-1 text-left">
                                <ion-select interface="action-sheet"
                                        [(ngModel)]="currentYear"
                                        class="text-input"
                                        name="year"
                                        (ionChange)="changeYear($event)"
                                        value="{{currentYear}}"

                                >
                                    <ion-select-option *ngFor="let y of years" [value]="y">{{y}}</ion-select-option>
                                </ion-select>
                            </div>
                        </div>

                        <div id="chart-cnt"></div>

                        <div class="floating-footer center-content">
                            <div class="flex-left text-center">Fatturato</div>
                            <div class="flex-right text-center">
                                {{ totals[currentYear] | currency: "EUR" }}
                            </div>
                        </div>
                        <!-- ...a qui -->
                    </div>
                </div>
            </div>

            <!-- <div class="floating-btn drop-shadow">+</div> -->
        </ion-content>
    </div>
</div>
